import Vue from 'vue'
import service from '../services/document-requests-service'

export function useDocumentRequest() {
  const state = Vue.observable({
    items: [],
    currentPage: 1,
    lastPage: 1,
    loading: false
  })

  async function getDocumentRequest(params = {}) {
    state.loading = true
    try {
      const response = await service.getDocumentRequest(params)
      state.items = response.vendors.current_page === 1
        ? [...response.vendors.data]
        : [...state.items, ...response.vendors.data]
      state.currentPage = response.vendors.current_page
      state.lastPage = response.vendors.last_page
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function updateDocumentRequest(params = {}) {
    state.loading = true
    try {
      const response = await service.updateDocumentRequest(params)
      state.items = state.items.map(item =>
        item.id === response.item.id
          ? { ...item, rps_request_status_id: response.item.statusId, statusName: response.item.statusName, statusColor: response.item.statusColor }
          : item
      )
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function deleteDocumentRequest(params = {}) {
    state.loading = true
    try {
      const response = await service.deleteDocumentRequest(params)
      state.items = state.items.filter(item => item.id !== response.item.id)
      // state.items = state.items.map(item =>
      //   item.id === response.item.id
      //     ? { ...item, rps_request_status_id: response.item.statusId, statusName: response.item.statusName, statusColor: response.item.statusColor }
      //     : item
      // )
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function getClients(params = {}) {
    state.loading = true
    try {
      const response = await service.getClients(params)
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function getDocument(params = {}) {
    state.loading = true
    try {
      const response = await service.getDocument(params)
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function addRequest(params = {}) {
    state.loading = true
    try {
      const response = await service.addRequest(params)
      state.items = [...state.items,response.item]
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function uploadFiles(params = {}) {
    state.loading = true
    try {
      const response = await service.uploadFiles(params)
      state.items = state.items.map(item =>
        item.id === response.item.id
          ? { ...item, rps_request_status_id: response.item.statusId, statusName: response.item.statusName, statusColor: response.item.statusColor }
          : item
      )
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function getFiles(payload) {
      state.loading = true
      try {
        const response = await service.getFiles(payload)
        if (!response || typeof response !== "object") {
          return { success: false, error: "Respuesta inválida del servidor" }
        }
        return { success: true, response }
      } catch (err) {
        return { success: false, error: err }
      } finally {
        state.loading = false
      }
    }

  async function addRequestAuto(params = {}) {
    state.loading = true
    try {
      const response = await service.addRequestAuto(params)
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }


  return { state, getDocumentRequest, updateDocumentRequest, deleteDocumentRequest, getDocument, getClients, addRequest,addRequestAuto,uploadFiles,getFiles}
}
